var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"128px","max-height":"50px"}},[_c('v-select',{attrs:{"items":_vm.languagePack,"label":_vm.languageText,"solo":""},on:{"change":_vm.changeLanguage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }